import React from 'react';
import {
  GridRowCardByRowContainer,
  GridRowCardByRowItem,
  GridRowCardByRowStrong,
  GridRowCardByRowLabel,
  GridRowCardByRowValue,
  GridRowCardByRowButton,
} from './styles'
import { BsPlus } from 'react-icons/bs';
import { formatData, formatDateToDefaultUS } from '../../helpers/date';
import { formatPrice } from '../../helpers/price';
import { useHistory } from 'react-router-dom';
import colors from '../../assets/styles/colors';
import redirectToCorrectPageCdt from '../../services/redirectToCorrectPageCdt';
import { BsPersonCheck, BsArrowRightShort } from 'react-icons/bs';

function formatPeriodicity(periodicity) {
  return periodicity;
}

const GridRowCard = ({ item, canalEstado, setShowModalAnular, setIdCreditAnular }) => {
  const history = useHistory();

  return (
    <GridRowCardByRowContainer id="card">
      <GridRowCardByRowItem>
        <GridRowCardByRowStrong>{item.email}</GridRowCardByRowStrong>
      </GridRowCardByRowItem>
      <GridRowCardByRowItem>
        <GridRowCardByRowLabel>Inversión</GridRowCardByRowLabel>
        <GridRowCardByRowValue>$ {formatPrice(parseFloat(item.monto.balance))}</GridRowCardByRowValue>
      </GridRowCardByRowItem>
      <GridRowCardByRowItem>
        <GridRowCardByRowLabel>Tasa</GridRowCardByRowLabel>
        <GridRowCardByRowValue>{formatPeriodicity(item.intereses.tasa)}% MV</GridRowCardByRowValue>
      </GridRowCardByRowItem>
      <GridRowCardByRowItem>
        <GridRowCardByRowLabel>Fecha apertura:</GridRowCardByRowLabel>
        <GridRowCardByRowValue>{formatData(item.fechaCreacion)}</GridRowCardByRowValue>
      </GridRowCardByRowItem>
      <GridRowCardByRowItem>
        <GridRowCardByRowLabel>Ver Detalle</GridRowCardByRowLabel>
        <GridRowCardByRowValue>
            <GridRowCardByRowButton id="select-item" onClick={() => redirectToCorrectPageCdt(history, item)}>
              <BsArrowRightShort size={22} color={colors.green} id="plus-icon" />
            </GridRowCardByRowButton>
        </GridRowCardByRowValue>
      </GridRowCardByRowItem>
      <GridRowCardByRowItem>
      </GridRowCardByRowItem>
    </GridRowCardByRowContainer>
  )
}
           
export default GridRowCard;